
import * as echarts from 'echarts';

import { getDevDetails, getDevAttr, getDevAttrName, getDevHisData, getDevByDevId } from "@/api/device";
import { getPoliceList, getInsertPolice, getPoliceDel, getPoliceDetails, getPhoneByProject, getUpdatePolice, getPoliceHisList, getPoliceProcess } from "@/api/warning";

import moment from 'moment';
export default {
    name: "deviceDetails",
    data() {

        return {
            id: this.$route.query.id,
            device_id: this.$route.query.device_id,
            project_id: this.$route.query.project_id,
            device_name: this.$route.query.device_name,

            tabs: [
                {
                    id: 'realTimeData',
                    name: '实时数据'
                }, {
                    id: 'alarmInfo',
                    name: '报警信息'
                },
            ],
            tabsActive: 'realTimeData',

            tableData: [],
            tableColumn: [
                {
                    id: '1',
                    prop: 'attrName',
                    label: '点位名称',
                }, {
                    id: '2',
                    prop: 'dataValue',
                    label: '点位当前值',
                    className: 'bold',
                }, {
                    id: '3',
                    prop: 'date',
                    label: '更新时间'
                }, {
                    id: '9',
                    prop: 'handle',
                    label: '操作',
                    xqliHandle: true
                },
            ],

            warningData: [],
            warningColumn: [
                {
                    id: '1',
                    prop: 'createTime',
                    label: '报警时间'
                }, {
                    id: '2',
                    prop: 'dpName',
                    label: '报警点位'
                }, {
                    id: '3',
                    prop: 'triggers',
                    label: '报警内容'
                }, {
                    id: '4',
                    prop: 'eventLevelName',
                    label: '报警等级'
                }, {
                    //     id: '5',
                    //     prop: 'rulesState',
                    //     label: '报警状态'
                    // }, {
                    id: '6',
                    prop: '',
                    label: '报警持续时长'
                }, {
                    id: '7',
                    prop: 'process',
                    label: '操作',
                    xqliHandle: true
                },
            ],

            total: null,
            pageSize: 20,
            page: 1,

            selectVal: '',
            dataType: '',//数据类型
            attrName: '',//点位名称
            projectName: '',//项目名称
            deviceName: '',//设备名称
            attrNameList: [],//设备属性namelist

            deviceStatus: this.$route.query.deviceStatus,
            detailsData: [//详情数据
                {
                    id: 'device_id',
                    key: '设备编号',
                    val: '',
                }, {
                    id: 'sn',
                    key: 'SN序列号',
                    val: '',
                }, {
                    id: 'device_name',
                    key: '设备名称',
                    val: '',
                }, {
                    id: 'device_brand',
                    key: '设备品牌',
                    val: this.$route.query.deviceBrandName,
                }, {
                    id: 'device_spec',
                    key: '设备型号',
                    val: '',
                },
            ],
            detailsDataRight: [//详情数据
                {
                    id: 'customer_name',
                    key: '所属客户',
                    val: '',
                }, {
                    id: 'project_name',
                    key: '所属项目',
                    val: '',
                }, {
                    id: 'region_name',
                    key: '项目地址',
                    val: '',
                }, {
                    id: 'activateTime',
                    key: '设备激活时间',
                    val: '',
                }, {
                    id: 'onlineTime',
                    key: '最近同步时间',
                    val: '',
                },
            ],

            xAxisData: [],
            seriesData: [],

            tableDataHour: [],
            tableColumnHour: [
                {
                    id: '1',
                    prop: 'time',
                    label: '采集时间'
                }, {
                    id: '2',
                    prop: 'val',
                    label: '值'
                },
            ],

            timer: null,
            nameplateUrl: require('../../../../assets/images/nameplate.png'),
            srcList: [],

            pupUp: false,
            eventHistoryIdent: '',

            ruleForm: {
                alarmRadio: 1,
                textarea: '',
            },
            rules: {
                textarea: [{ required: true, message: '请输入处理方法，200字以内', trigger: 'blur' }]
            },

        }
    },
    computed: {

    },
    watch: {
        selectVal(val) {
            this.dataType = this.attrNameList.filter(el => el.attrIdent === val)[0].dataType
            this.attrName = this.attrNameList.filter(el => el.attrIdent === val)[0].attrName
            this.getDevHisData()
        },
    },

    created() {

        this.getDevDetails()
        this.getDevByDevId()
        this.getDevAttr()// 点位实时数据
        this.getDevAttrName()// 设备属性名称 echart上面的下拉选项
        this.getPoliceHisList()

        this.timer = setInterval(() => {
            this.getDevAttr()
            this.getDevHisData()
            this.getDevDetails()
        }, 10000)
    },
    mounted() {

    },

    beforeDestroy() {
        clearInterval(this.timer)
    },

    methods: {

        async getDevDetails() {//设备详情
            let params = {
                projectId: this.project_id,
                id: this.id,
                deviceIdent: this.device_id
            }
            const res = await getDevDetails(params)
            if (res.code === 200) {
                this.deviceName = res.data.device_name
                this.projectName = res.data.project_name
                this.detailsData.forEach(el => {
                    if (el.id === 'device_brand') return;
                    el.val = res.data[el.id] ? res.data[el.id] : ''
                });
                this.detailsDataRight.forEach(el => {
                    if (el.id === 'activateTime' || el.id === 'onlineTime'){
                        el.val = res.data[el.id] ? moment(res.data[el.id],'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD HH:mm:ss') : ''
                    }else{
                        el.val = res.data[el.id] ? res.data[el.id] : ''
                    }
                });
            }
        },

        async getDevByDevId() {
            const res = await getDevByDevId(this.id)
            this.srcList = []
            if (res.code == 200) {
                res.data.forEach(el => {
                    if (el.url) {
                        this.srcList.push(el.url)
                    }
                })
            }
        },

        async getDevAttr() { // 点位实时数据
            const res = await getDevAttr(this.device_id)
            if (res.code === 200) {
                this.tableData = res.data.rows || []
                this.tableData.forEach(el => {
                    el.date = el.date ? this.moment(el.date, 'x').format('YYYY-MM-DD HH:mm:ss') : ''
                })
            }
        },

        async getDevAttrName() {//设备属性名称 echart上面的下拉选项
            const res = await getDevAttrName(this.device_id)
            if (res.code === 200) {
                this.attrNameList = res.data
                if (res.data.length > 0) {
                    this.selectVal = res.data[0].attrIdent
                    this.dataType = res.data[0].dataType
                    this.getDevHisData()
                }
            }
        },

        async getDevHisData() {//近一小时历史数据
            let params = {
                deviceIdent: this.device_id,
                attrIdent: this.selectVal,
                start: this.moment().subtract(1, 'hours').format('x'),
                end: this.moment().format('x')
            }
            const res = await getDevHisData(params)
            if (res.code === 200) {
                let data = res.data.rows
                this.total = res.data.total

                this.xAxisData = []
                this.seriesData = []
                let dataArr = []
                for (let k in data) {
                    dataArr.push({ key: k, val: data[k] })
                }
                dataArr.sort((a, b) => { return a.key - b.key })
                if (this.dataType !== 'String') {
                    dataArr.forEach(el => {
                        this.xAxisData.push(this.moment(el.key, 'x').format('HH:mm:ss'))
                        this.seriesData.push(el.val)
                    })
                    this.getDataTrendEchart()
                } else {
                    this.tableDataHour = []
                    dataArr.forEach(el => {
                        this.tableDataHour.push({
                            time: this.moment(el.key, 'x').format('YYYY-MM-DD HH:mm:ss'),
                            val: el.val
                        })
                    })
                }
            }
        },

        async getPoliceHisList() {//30天报警信息
            let params = {
                page: 1,
                offset: 10000,
                sortBy: '',
                order: '',
                isRead: '',
                projectId: this.project_id, //项目id
                deviceIdent: [this.device_id], //设备标识

                startTime: moment().subtract(30, 'days').format('x').slice(0, 10), //开始时间
                endTime: moment().format('x').slice(0, 10), //结束时间
            }
            const res = await getPoliceHisList(params)
            if (res.code == 200) {
                let data = res.data.rows
                data.forEach(el => {
                    let eventLevelName = ''
                    switch (el.eventLevel) {
                        case 1:
                            eventLevelName = '低级'
                            break;
                        case 2:
                            eventLevelName = '中级'
                            break;
                        case 3:
                            eventLevelName = '高级'
                            break;
                    }
                    el.eventLevelName = eventLevelName
                    el.rulesState = el.process == 0 ? '报警中' : '恢复正常'

                    let trigAttr = el.trigAttr ? JSON.parse(el.trigAttr) : []
                    let trigAttrName = el.trigAttrName ? JSON.parse(el.trigAttrName) : []
                    let trigCondition = el.trigCondition ? JSON.parse(el.trigCondition) : []
                    let indexArr = this.findall(trigCondition || [], '%s')

                    el.dpName = trigAttrName[0] ? trigAttrName[0] : ''
                    el.dpId = trigAttr[0] ? trigAttr[0] : ''
                    el.sign = trigCondition[1] ? trigCondition[1] : ''
                    el.val = trigCondition[2] ? trigCondition[2] : ''
                    for (let i = 0; i < indexArr.length; i++) {
                        trigCondition.splice(indexArr[i], 1, trigAttrName[i])
                    }

                    el.triggers = trigCondition.join('')
                })
                this.warningData = data
            }
        },

        getDataTrendEchart() {
            let option = {
                grid: {
                    top: '10%',
                    left: '1%',
                    right: '3%',
                    bottom: '3%',
                    containLabel: true
                },
                tooltip: {
                    trigger: 'axis',
                },
                xAxis: {
                    type: 'category',
                    // data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
                    data: this.xAxisData
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    // data: [150, 230, 224, 218, 135, 147, 260],
                    name: this.attrName,
                    data: this.seriesData,
                    type: 'line'
                }]
            }
            let myChart = echarts.init(document.getElementById('trendEchart'));
            myChart.setOption(option);


            // this.$nextTick(()=>{
            //     myChart.setOption(option);
            // })
        },

        handleHistory(data) {//查看历史
            this.selectVal = data.attrIdent
        },

        handleClickMoreHistory(row) {
            this.$router.push({
                name: 'historicalData',
                query: {
                    projectId: this.project_id,
                    deviceId: this.device_id,
                    attrIdent: row.attrIdent,
                    attrName: row.attrName,
                    projectName: this.projectName,
                    deviceName: this.deviceName,
                }
            })
        },

        handleClickMoreWarningHistory() {
            this.$router.push({ name: 'alarmHistory' })
        },


        handleDispose(row) {
            this.pupUp = true
            this.eventHistoryIdent = row.eventHistoryIdent
            this.process = row.process
        },

        // async handleConfirm() {
        //     let params = {
        //         eventHistoryIdent: this.eventHistoryIdent,
        //         process: this.alarmRadio,
        //         processDesc: this.textarea
        //     }
        //     const res = await getPoliceProcess(params)
        //     if (res.code == 200) {
        //         this.pupUp = false
        //         this.getPoliceHisList()
        //     }
        // },
        // handleCancel() {
        //     console.log('取消')
        // },
        async handleConfirm() {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    let params = {
                        eventHistoryIdent: this.eventHistoryIdent,
                        process: this.ruleForm.alarmRadio,
                        processDesc: this.ruleForm.textarea
                    }
                    getPoliceProcess(params).then(res => {
                        if (res.code == 200) {
                            this.pupUp = false
                            this.$refs['ruleForm'].resetFields();
                            this.getPoliceHisList()
                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        handleCancel() {
            this.$refs['ruleForm'].resetFields();
        },

        handleClickImage() {
            if (this.srcList.length === 0) {
                this.$message({ message: '暂无铭牌信息', type: 'warning' });
            }
        },




        findall(a, x) {//查找数组中某个值出现的所有下标
            let results = [],
                len = a.length,
                pos = 0;
            while (pos < len) {
                pos = a.indexOf(x, pos);
                if (pos === -1) {//未找到就退出循环完成搜索
                    break;
                }
                results.push(pos);//找到就存储索引
                pos += 1;//并从下个位置开始搜索
            }
            return results;
        },

    },
}
